import { HoneypotField, InputField, NameField, PasswordField, TurnstileWidget } from "components";
import { fieldLimits } from "config";
import { useField } from "formik";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import styles from "../Register.module.css";

const RegisterFormBody = () => {
	const { t } = useTranslation("accountsPage");
	const [honeypot] = useField<string>({ name: "website" });
	const [, , turnstileHelpers] = useField<string>({ name: "turnstileToken" });

	// setValue is stable per Formik field, but wrapping it keeps the widget's effect from re-running
	// if that ever stops being true.
	const onTurnstileToken = useCallback(
		(token: string): void => {
			turnstileHelpers.setValue(token);
		},
		[turnstileHelpers]
	);

	return (
		<div className={styles.body}>
			<NameField
				autoComplete="name"
				label={t("register.fullNameLabel")}
				maxLength={fieldLimits.fullName}
				name="fullName"
				placeholder={t("register.fullNamePlaceholder")}
			/>
			<InputField
				autoComplete="email"
				label={t("register.emailLabel")}
				maxLength={fieldLimits.email}
				name="email"
				placeholder={t("register.emailPlaceholder")}
				type="email"
			/>
			<PasswordField
				autoComplete="new-password"
				label={t("register.passwordLabel")}
				maxLength={fieldLimits.password}
				name="password"
				placeholder={t("register.passwordPlaceholder")}
			/>
			<HoneypotField id="register-website" onChange={honeypot.onChange} value={honeypot.value} />
			<TurnstileWidget onTokenChange={onTurnstileToken} />
		</div>
	);
};

export default RegisterFormBody;
